<template>
  <div></div>
</template>

<script>
  import { notification, Button } from 'ant-design-vue';
  import { h } from 'vue';
  import {useRouter} from "vue-router";
  import {onBeforeMount} from "@vue/runtime-core";
  import {computed} from "@vue/reactivity";
  import {useStore} from "vuex";
  export default {
    setup() {

      const router = useRouter();
      const store = useStore();

      const personalActivity = computed(() => store.state.personalActivity);
      const closedNotificationStorageKey = 'unfinishedPassingNotificationClosed';
      const notificationCloseDelay = 60 * 60 * 1000;

      const getClosedNotifications = () => {
        try {
          const notifications = JSON.parse(localStorage.getItem(closedNotificationStorageKey)) ?? [];

          return Array.isArray(notifications) ? notifications : [];
        } catch (e) {
          return [];
        }
      };

      const setClosedNotifications = (notifications) => {
        localStorage.setItem(closedNotificationStorageKey, JSON.stringify(notifications));
      };

      const saveClosedNotification = (code) => {
        const notifications = getClosedNotifications()
            .filter((item) => Date.now() - new Date(item.date).getTime() < notificationCloseDelay)
            .filter((item) => item.code !== code);

        notifications.push({
          code,
          date: new Date().toISOString(),
        });

        setClosedNotifications(notifications);
      };

      const wasNotificationRecentlyClosed = (code) => {
        const notifications = getClosedNotifications();
        const recentNotifications = notifications.filter((item) => (
            item?.code && item?.date && Date.now() - new Date(item.date).getTime() < notificationCloseDelay
        ));

        if (recentNotifications.length !== notifications.length) {
          setClosedNotifications(recentNotifications);
        }

        return recentNotifications.some((item) => item.code === code);
      };

      const openNotification = (code) => {
        const key = `open${Date.now()}`;

        notification.open({
          message: 'Напоминание о тестировании',
          duration: 0,
          description:
              'Вы не завершили тестирование. Не забудьте пройти его.',
          btn: () =>
              h(
                  Button,
                  {
                    class: 'primary-button',
                    onClick: () => {
                      saveClosedNotification(code);
                      notification.close(key);
                      router.push('/passing/' + code);
                    },
                  },
                  { default: () => 'Открыть' },
              ),
          key,
          onClose: () => {
            saveClosedNotification(code);
          },
        });
      };

      onBeforeMount(() => {
        store.dispatch('getPersonalActivity').then(() => {
          const firstUnfinished = personalActivity.value.passings?.find(
              (p) => p.status !== "finished" && !wasNotificationRecentlyClosed(p.code)
          );

          if (firstUnfinished) {
            openNotification(firstUnfinished.code);
          }
        });
      });
    }
  }
</script>
